const ethers = require('ethers')
const abi = require('./kvabi')
const axios = require('axios')

const rpcEndPoint =  'https://matic-mumbai.chainstacklabs.com' //'https://polygon-rpc.com/'
const provider = new ethers.providers.JsonRpcProvider(rpcEndPoint)

const contractAddress = '0x3Efdf18105324148E3a72B1730A73ED336080829'//'0x9ba13d6036196daa46c408ca21bac64e32d41fca'
const key = 'bmYieldIndex'

const contract = new ethers.Contract(contractAddress, abi, provider)

const get = async () => {
    let cid = await contract['get(string)'](key)
    let ret = await axios.get('https://nftupload.infura-ipfs.io/ipfs/' + cid)
    let data = ret.data
    console.log(ret)
    try{
        data = JSON.parse(data)
    }
    catch(e){}
    return data
}

export {get}


